import { render } from "./ReportTotalsByCardType.vue?vue&type=template&id=3682395c&scoped=true"
import script from "./ReportTotalsByCardType.vue?vue&type=script&lang=js"
export * from "./ReportTotalsByCardType.vue?vue&type=script&lang=js"

import "./ReportTotalsByCardType.vue?vue&type=style&index=0&id=3682395c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3682395c"]])

export default __exports__